import { useAuthStore } from '@/feature/auth/store/auth'
import { MyTelemetryCredentials } from '@/feature/telemetry'

import { request, useNetworkRequest } from '@/lib/utils/request'

const makeApi = (instance = request) => ({
  getMyTelemetry: () => instance.get<MyTelemetryCredentials>('v1/organizations/my/telemetry/'),
})
export const api = makeApi()
export const useTelemetryCredentials = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useNetworkRequest<MyTelemetryCredentials>(
    isAuthenticated ? 'v1/organizations/my/telemetry/' : null,
  )
}
